import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <div className="relative bg-gradient-to-br from-green-100 via-amber-50 to-white py-20 px-8 mb-10 rounded-3xl shadow-xl overflow-hidden group">
      <Link to="/about" className="absolute top-6 right-6 z-20 px-4 py-2 bg-white/50 backdrop-blur-sm border border-emerald-900/10 rounded-full text-emerald-900 font-medium text-sm hover:bg-emerald-900 hover:text-white transition-all active:scale-95 shadow-sm">
        About / Contact
      </Link>
      <img
        src="/hero-bali.jpg"
        alt="Bali Rentals"
        className="absolute inset-0 object-cover w-full h-full rounded-3xl opacity-20"
      />
      <div className="relative z-10 text-center max-w-3xl mx-auto">
        <h1 className="text-5xl font-extrabold text-emerald-900 mb-4 tracking-tight leading-tight drop-shadow-md font-raleway">
          Bali Rental Finder
        </h1>
        <h2 className="text-3xl md:text-4xl font-light text-emerald-800 italic mb-4 drop-shadow-sm font-inter">
          Find Your Long-Term Home in Paradise
        </h2>
        <p className="text-lg md:text-xl text-gray-700 font-light font-inter">
          Explore peaceful villas, cozy studios, and digital nomad-friendly spaces across Bali.
        </p>
      </div>
    </div>
  );
}
